import React, { lazy } from 'react';
export function ProductHero() {
  return <section className="bg-[#1B3A6B] py-6 md:py-12 lg:py-[60px] text-center" data-id="element-187">
      <div className="container mx-auto px-4" data-id="element-188">
        <div className="inline-block bg-[#FF6B35] text-white font-poppins font-bold px-6 py-2 rounded-full text-sm mb-4 md:mb-5" data-id="element-189">
          SOLUCIÓN INTEGRAL
        </div>

        <h2 className="text-white font-poppins font-black text-3xl md:text-6xl mb-4 md:mb-5 max-w-5xl mx-auto" data-id="element-190">
          🚨 CÓDIGO DE EMERGENCIA ESCOLAR™ NIVEL PRIMARIO — PACK COMPLETO
        </h2>

        <p className="text-[#FFD700] font-poppins font-bold text-xl md:text-2xl mb-5 md:mb-8" data-id="element-191">
          4 Módulos + 3 Bonos · 260+ páginas Todo lo que necesitás para
          prevenir, actuar y acompañar en primaria.
        </p>

        <div className="max-w-4xl mx-auto mb-5 md:mb-8" data-id="element-192">
          <img src="https://cdn.magicpatterns.com/uploads/rzfibkpJEqjQkydDx9baQw/codigo-emergencia-escolar-optimized.webp" alt="Product Mockup" className="w-full h-auto md:drop-shadow-[0_0_50px_rgba(255,215,0,0.2)]" loading="lazy" decoding="async" width="1200" height="900" sizes="(max-width: 768px) 90vw, 800px" data-id="element-193" />
        </div>

        <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6 text-white font-bold text-lg" data-id="element-194">
          <div className="flex items-center justify-center gap-3" data-id="element-195">
            <span className="text-[#2D9B6F] text-2xl" data-id="element-196">✅</span>
            Desarrollado específicamente para el nivel primario argentino.
          </div>
          <div className="flex items-center justify-center gap-3" data-id="element-197">
            <span className="text-[#2D9B6F] text-2xl" data-id="element-198">✅</span>
            100% adaptado a la realidad legal y educativa de Argentina 2026.
          </div>
        </div>
      </div>
    </section>;
}